import { EventEmitter, Injectable } from "@angular/core";
import { MainService } from "./service.service";
import {
  AdveristmentsClient,
  DTOAdvertisementCategory,
  DTORegion,
  AdveristmentCreateResponse,
  AdveristmentUpdateResponse,
  AdveristmentGetResponse,
  AdveristmentGetModel,
  AdveristmentCreateModel,
  AdveristmentUpdateModel,
  IAdveristmentCreateModel,
  IAdveristmentUpdateModel,
  DTOAdvertisementImage,
  DTOAdvertisement,
  AdvertistmentRepostResponse,
  AdvertistmentRepostModel,
  AdveristmentDeleteModel,
  AdveristmentDeleteResponse, AdvertisementMarkAsSeenResponseModel, AdvertisementMarkAsSeenRequestModel, DTOSubRegion, AdWritterInformationRequest, IAddWriteAdTokenResponse, AddWriteAdTokenResponse, AdWritterInformationResponse
} from "../api/WickedApiClient";
import { FileInfo } from "../Models/FileModels";
import { DTOAdvertisementEx } from "../api/LocalModels";
import { IAdveristmentGetModel, BannersClient } from '../api/WickedApiClient';
import { HttpClient } from "@angular/common/http";
import { Observable, Subject, BehaviorSubject, of, ReplaySubject } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { GeolocationService } from "./geolocation.service";
import { RegexSearchList } from "./searchroute.service";

export enum ViewMode {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  ALL = 'ALL'
}

declare const CATEGORIES: DTOAdvertisementCategory[];

@Injectable({
  providedIn: "root"
})
export class AdvertisementService {
  services: MainService = null;
  categories: DTOAdvertisementCategory[] = [];
  regions: DTORegion[] = [];
  googleApiKey: string;
  blogURL: string;

  private _bannersEnabled: boolean = false;
  public get bannersEnabled(): boolean {
    return this._bannersEnabled;
  }
  public set bannersEnabled(value: boolean) {
    this._bannersEnabled = value;
  }

  private _useBannerProviders: boolean = null;
  public get useBannerProviders(): boolean {
    return this._useBannerProviders;
  }
  public set useBannerProviders(value: boolean) {
    this._useBannerProviders = value;
  }

  constructor(private advClient: AdveristmentsClient, private http: HttpClient, private bannersCLient: BannersClient, private cookieService: CookieService, private geolocationClient: GeolocationService) {
    this.searchDataStandard = new searchData(geolocationClient);
    this.searchDataUserAdv = new searchData();

    this.getGoogleApiKey();
    this.getBlogUrl();
    this.bannersCLient.getBannersEnabled().subscribe(v=>{
      this.bannersEnabled = (v=="True")?true:false;
      this.bannersCLient.getUseBannerProviders().subscribe(v=>{
        this.useBannerProviders = (v=="True")?true:false;
      })
    })


    //  this.searchActionForUser();
  }

  public getGoogleApiKey() {
    this.advClient.getGoogleKey().subscribe(v => {
      this.googleApiKey = v;
    });
  }

  public getBlogUrl() {
    this.advClient.getBlogUrl().subscribe(v => {
      this.blogURL = v;
    });
  }


  public getLocationDataByZipCode(zipcode: string) {
    const url: string = `https://maps.googleapis.com/maps/api/geocode/json?key=${this.googleApiKey}&components=postal_code:${zipcode}`;
    return this.http.get(url);
  }

  public getCategoriesObservable(forceApi: boolean = false): Observable<DTOAdvertisementCategory[]> {
    if (!forceApi && CATEGORIES != undefined) {
      return of(CATEGORIES);
    } else {
      return this.advClient.getCategories();
    }
  }

  public getCategories(force: boolean = false): Promise<DTOAdvertisementCategory[]> {
    return new Promise<DTOAdvertisementCategory[]>((rs, rj) => {
      if (!force && CATEGORIES != undefined) {
        rs(CATEGORIES);
      } else {
        this.services.progress = true;
        if (this.categories && this.categories.length > 0) {
          rs(this.categories);
          this.services.progress = false;
        } else {
          this.advClient.getCategories().subscribe(result => {
            this.categories = result;
            rs(result);
            this.services.progress = false;
          });
        }
      }
    });
  }

  public delete(advertisementId: number) {
    this.services.progress = true;
    return new Promise<AdveristmentDeleteResponse>((rs, rj) => {
      this.advClient.delete(new AdveristmentDeleteModel({ advertisementId: advertisementId })).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public repost(repostModel: AdvertistmentRepostModel) {
    this.services.progress = true;
    return new Promise<AdvertistmentRepostResponse>((rs, rj) => {
      this.advClient.repost(repostModel).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }


  private singleRegions: DTORegion[] = [];

  private subRegionsByRegion: Map<number, DTOSubRegion[]> = new Map<number, DTOSubRegion[]>();


  private regionsLoading = false;


  public getRegionsOnly(): DTORegion[] {

    if (this.regionsLoading == true) {
      return this.singleRegions
    } else {
      if (this.singleRegions.length == 0) {
        this.regionsLoading = true;

        this.advClient.getRegionsOnly().subscribe(result => {
          result.forEach(x => {
            this.singleRegions.push(x)
          });
          this.regionsLoading = false;
        })
      }
      return this.singleRegions;
    }
  }

  public getSubRegionsForRegionPromise(regionId: number): Promise<DTOSubRegion[]> {

    return new Promise<DTOSubRegion[]>((rs, rj) => {
      if (!regionId) {
        rs([])
      }
      else {
        if (this.subRegionsByRegion.has(regionId) && this.subRegionsByRegion.get(regionId).length > 0) {
          rs(this.subRegionsByRegion.get(regionId))
        }
        else this.advClient.getChildrenSubRegions(regionId).subscribe(res => {
          const subRegions = [];
          res.forEach(r => {
            subRegions.push(r)
          })
          this.subRegionsByRegion.set(regionId, subRegions);
          rs(res)
        })
      }
    })
  }

  public getSubRegionsByRegionId(regionId: number) {
    if (!regionId) {
      return [];
    }
    if (this.subRegionsByRegion.has(regionId)) {
      return this.subRegionsByRegion.get(regionId)
    } else {
      const subRegions = [];
      this.subRegionsByRegion.set(regionId, subRegions);
      this.advClient.getChildrenSubRegions(regionId).subscribe(res => {
        res.forEach(r => {
          subRegions.push(r)
        })
      });
      return subRegions;
    }
  }

  public getRegionsObservable(): Observable<DTORegion[]> {
    return this.advClient.getRegionsOnly();
  }

  public getRegionsOnlyPromise(): Promise<DTORegion[]> {
    return new Promise<DTORegion[]>((rs, rj) => {
      if (!this.regionsLoading && this.regions.length == 0) {
        this.regionsLoading = true;

        this.advClient.getRegionsOnly().subscribe(result => {
          this.regionsLoading = false;
          result.forEach(x => {
            this.singleRegions.push(x)
          });
          this.regionsLoading = false;
          rs(this.singleRegions)
        })
      }
    })
  }

  public getSubRegionNameById(regionId: number, subregionId: number) {

    let subRegions = this.getSubRegionsByRegionId(regionId).filter(s => s.subRegionId == subregionId);
    if (subRegions != null && subRegions.length > 0) {
      return subRegions[0].name
    }
    else return "";
  }

  public getRegionNameById(id: number) {
    let region = this.singleRegions.filter(v => {
      return v.regionId == id;
    });
    return region[0];
  }

  public create(
    userNick: string,
    title: string,
    content: string,
    region: number,
    subregion: number | null | undefined,
    postalCode: string,
    casualDating: boolean,
    relationShips: number,
    publish: boolean,
    age: string,
    images: FileInfo[],
    isPremium: boolean,
    isThirdParty: boolean
  ): Promise<AdveristmentCreateResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentCreateResponse>((rs, rj) => {
      var req = new AdveristmentCreateModel();
      var imagesToSave: DTOAdvertisementImage[] = images.map((x, index) => {
        var r = new DTOAdvertisementImage();
        r.init(x);
        return r;
      });
      req.init({
        userNick: userNick,
        advertisementCategoryId: relationShips,
        casualDating: casualDating,
        content: content,
        images: imagesToSave,
        published: publish,
        regionId: region,
        subRegionId: subregion,
        title: title,
        zipCode: postalCode,
        age: age,
        userId: this.services.userService.getUserId(),
        isDemo: false,
        seen: false,
        seenAdmin: false,
        isPremium: isPremium,
        isThirdParty: isThirdParty
      });

      this.advClient.create(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public update(
    manageId: string,
    id: number,
    userId: number,
    userNick: string,
    title: string,
    content: string,
    region: number,
    subregion: number | null | undefined,
    postalCode: string,
    casualDating: boolean,
    relationShips: number,
    publish: boolean,
    age: string,
    images: FileInfo[],
    isPremium: boolean,
    isThirdParty: boolean
  ): Promise<AdveristmentUpdateResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentUpdateResponse>((rs, rj) => {
      var req = new AdveristmentUpdateModel();
      var imagesToSave: DTOAdvertisementImage[] = images.map((x, index) => {
        var r = new DTOAdvertisementImage();
        r.init(x);
        return r;
      });
      req.init({
        manageId: manageId,
        advertisementId: id,
        userId: userId,
        userNick: userNick,
        advertisementCategoryId: relationShips,
        casualDating: casualDating,
        content: content,
        images: imagesToSave,
        published: publish,
        regionId: region,
        subRegionId: subregion,
        title: title,
        age: age,
        seen: false,
        seenAdmin: false,
        isPremium: isPremium,
        isThirdParty: isThirdParty,
        zipCode: postalCode,
        isDemo: false
      });
      this.advClient.update(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public getAdvertisementData(advertisementId: number): Promise<AdveristmentGetResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentGetResponse>((rs, rj) => {
      this.advClient.getAdvertisementData(advertisementId).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public get(id: number, conversationKey: string = null): Promise<AdveristmentGetResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentGetResponse>((rs, rj) => {
      var req = new AdveristmentGetModel();
      req.init({
        byId: id,
        conversationKey: conversationKey
      });
      this.advClient.get(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public getByManageId(manageId: string): Promise<AdveristmentGetResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentGetResponse>((rs, rj) => {
      var req = new AdveristmentGetModel();
      req.init({
        manageId: manageId
      });
      this.advClient.get(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public getAll(): Promise<AdveristmentGetResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentGetResponse>((rs, rj) => {
      var req = new AdveristmentGetModel();
      req.init(this.searchDataStandard.currentSearchRule);
      this.advClient.get(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public getAllFromUser(viewMode: ViewMode | undefined = undefined): Promise<AdveristmentGetResponse> {
    this.services.progress = true;
    return new Promise<AdveristmentGetResponse>((rs, rj) => {
      const req = new AdveristmentGetModel();
      if (viewMode) {
        this.searchDataUserAdv.currentSearchRule.showActive = (viewMode == ViewMode.ACTIVE || viewMode == ViewMode.ALL);
        this.searchDataUserAdv.currentSearchRule.showExpired = (viewMode == ViewMode.EXPIRED || viewMode == ViewMode.ALL);
      }
      else {
        this.searchDataUserAdv.currentSearchRule.showActive = true;
        this.searchDataUserAdv.currentSearchRule.showExpired = true;
      }
      req.init(this.searchDataUserAdv.currentSearchRule);

      this.advClient.get(req).subscribe(result => {
        this.services.progress = false;
        if (result.error) {
          rj(result.error);
        } else {
          rs(result);
        }
      });
    });
  }

  public searchDataStandard: searchData;// = new searchData();
  public searchDataUserAdv: searchData; //= new searchData();

  private _searchInAction: boolean = false;

  public searchInActionChanged: Subject<boolean> = new BehaviorSubject<boolean>(false)
  public set searchInAction(value: boolean) {
    this.searchInActionChanged.next(value);
    this._searchInAction = value;
  }

  public get searchInAction() {
    return this._searchInAction;
  }


  public performSearchActionWithoutNavigateToSearchResult() {
    this.searchAction(false)
  }

  public clearSearchData() {
    this.searchDataStandard = new searchData();
    this.searchDataUserAdv = new searchData();
  }

  public resultListUpdate: Subject<any> = new Subject<any>();

  public searchAction(navigateToSearchResult: boolean = true, navigateURL: string = "") {
    this.searchInAction = true;
    const searchDataExpiresAt = new Date().getDate() + 2;
    this.getAll().then(result => {
      this.services.advService.searchDataStandard.RegionShortName = result.regionShortName
      this.services.advService.searchDataStandard.SubregionName = result.subRegionName;
      this.services.advService.searchDataStandard.ClosestSubregionNameIfNoResult = result.closestSubregionNameIfNoResult;
      //this.services.advService.searchDataStandard.currentSearchRule.nonDemoOnly = false;
      this.searchDataStandard.resultList = <DTOAdvertisementEx[]>result.adveristments.map(r => {
        const res = new DTOAdvertisementEx();
        res.init(r);
        return r;
      });
      this.searchDataStandard.resultCount = result.totalResultsCount;
      this.resultListUpdate.next();
      if (navigateToSearchResult) {
          this.services.route.navigate([navigateURL]);
      }
      this.searchInAction = false;
    });
  }

  public searchActionForUser(viewMode: ViewMode | undefined = undefined) {
    this.searchInAction = true;
    this.getAllFromUser(viewMode).then(v => {
      this.searchDataUserAdv.RegionShortName = v.regionShortName
      this.searchDataUserAdv.SubregionName = v.subRegionName;
      this.searchDataUserAdv.ClosestSubregionNameIfNoResult = v.closestSubregionNameIfNoResult;
      this.searchDataUserAdv.resultList = <DTOAdvertisementEx[]>v.adveristments.map(r => {
        var res = new DTOAdvertisementEx();
        res.init(r);
        return r;
      });
      
      this.searchDataUserAdv.resultCount = v.totalResultsCount;
      this.resultListUpdate.next();
      this.searchInAction = false;
    });
  }

  markAdvertisementAsSeen(advertisementId: number, isAdmin: boolean): Promise<AdvertisementMarkAsSeenResponseModel | void> {
    return new Promise<AdvertisementMarkAsSeenResponseModel | void>((rs, rj) => {
      const model = new AdvertisementMarkAsSeenRequestModel();
      model.advertisementId = advertisementId;
      model.isAdmin = isAdmin;
      this.advClient.markAsSeenByDemo(model).subscribe(result => {
        if (result.error) {
          rj(result.error)
        } else rs();
      })
    })
  }

  CreateAdWriteInformation(data: AdWritterInformationRequest): Promise<AdWritterInformationResponse> {
    return this.advClient.createAdWriteInformation(data).toPromise();
  }
}

export class searchData {

 

  constructor(geolocationClient: GeolocationService = null) {

    if (geolocationClient != null && !this.isSearchRoute()) {
      geolocationClient.GetGeolocationSearchModel().subscribe(response => {
        this._currentSearchRule = response;
        let data = { ...this._currentSearchRule };
        (data as any)._type = "geolocation";
        this.currentSearchRuleChanged.next(data);
      });
    }
  }

  isSearchRoute(): boolean {
    let regex = new RegExp(RegexSearchList, "gi");
    const paramsUrl = window.location.pathname.replace("/", "");
    var regexMatch = regex.exec(paramsUrl);
    if (regexMatch != null && (regexMatch as any).groups != null) {
      return true;
    } else {
      return false;
    }
  }

  public resultList: DTOAdvertisementEx[] = [];
  private _currentSearchRule: IAdveristmentGetModel = {
    pageNumber: 0,
    pageSize: 24,
    casualDating: false,
    showExpired: true,
    showActive: true
  };

  public isRouteSearchTrigger: Subject<boolean> = new ReplaySubject<boolean>(1);
  public currentSearchRuleChanged: Subject<IAdveristmentGetModel> = new ReplaySubject<IAdveristmentGetModel>(1);
  public geolocationSearchRuleChanged: Subject<IAdveristmentGetModel> = new ReplaySubject<IAdveristmentGetModel>(1);

  public get currentSearchRule(): IAdveristmentGetModel {
    return this._currentSearchRule;
  }

  public set currentSearchRule(value: IAdveristmentGetModel) {
    this._currentSearchRule = value;
    this.currentSearchRuleChanged.next(this._currentSearchRule);
  }

  private _resultCount: number = 0;
  private _expiredCount: number = 0;
  private _activeCount: number = 0;

  get expiredCount(): number {
    return this._expiredCount;
  }

  set expiredCount(value: number) {
    this._expiredCount = value;
  }

  get activeCount(): number {
    return this._activeCount;
  }

  set activeCount(value: number) {
    this._activeCount = value;
  }

  public get resultCount(): number {
    return this._resultCount;
  }

  public set resultCount(value: number) {
    this._resultCount = value;
  }

  private _closestSubregionNameIfNoResult: string = ""
  public get ClosestSubregionNameIfNoResult(): string {
    return this._closestSubregionNameIfNoResult;
  }

  public set ClosestSubregionNameIfNoResult(value: string) {
    this._closestSubregionNameIfNoResult = value;
  }

  private _regionShortName: string = "";
  public RegionShortNameChanged: Subject<string> = new Subject<string>()
  public get RegionShortName(): string {
    return this._regionShortName;
  }

  public set RegionShortName(value: string) {
    this._regionShortName = value;
    this.RegionShortNameChanged.next(value);
  }

  private _subregionName: string = "";
  public SubregionNameChanged: Subject<string> = new Subject<string>()
  public get SubregionName(): string {
    return this._subregionName;
  }

  public set SubregionName(value: string) {
    this._subregionName = value;
    this.SubregionNameChanged.next(value);
  }


}
